<template>
  <section class="island">
      <h2 v-if="header">{{ header }}</h2>

      <div class="island__content">
        <slot />
      </div>
  </section>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.island__content {
  @include layout-box;
  padding: measure(m);
}
</style>
